import { createTheme, Modal } from "@mantine/core";

const defaultInputSize =
	import.meta.env.VITE_CAPACITOR_BUILD === "true" ? "md" : "xs";

export const theme = createTheme({
	spacing: {
		xxs: "5",
	},

	components: {
		NavLink: {
			styles: {
				root: {
					borderRadius: 5,
				},
			},
		},
		PasswordInput: {
			defaultProps: {
				size: defaultInputSize,
				maw: 200,
			},
		},
		MultiSelect: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		Select: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		Input: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		InputBase: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		TextInput: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		Textarea: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		DatePickerInput: {
			defaultProps: {
				size: defaultInputSize,
				valueFormat: "MM/DD/YY",
			},
		},
		DateInput: {
			defaultProps: {
				size: defaultInputSize,
				valueFormat: "MM/DD/YY",
			},
		},
		NumberInput: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		TagsInput: {
			defaultProps: {
				size: defaultInputSize,
			},
		},
		Badge: {
			defaultProps: {
				size: "xs",
			},
		},
		Text: {
			defaultProps: {
				size: "xs",
			},
		},
		Button: {
			defaultProps: {
				size: "xs",
			},
		},
		ActionIcon: {
			defaultProps: {
				size: "xs",
			},
		},
		Switch: {
			defaultProps: {
				size: "xs",
			},
		},
		Pagination: {
			defaultProps: {
				size: "xs",
			},
		},
		Anchor: {
			defaultProps: {
				fw: 550,
				c: "blue",
			},
		},
		Overlay: {
			defaultProps: {
				className: "overlay",
				opacity: 0.9,
			},
		},
		Modal: Modal.extend({
			defaultProps: {
				overlayProps: {
					className: "overlay",
					opacity: 0.9,
				},
			},
			styles: (_theme, props) => ({
				content: props.fullScreen
					? {
							// The content element is the scroll container and the sticky header sticks to its padding box,
							// so a top padding would let the header scroll under the status bar. A border sits outside the
							// padding box, keeping both the header and header-less content below the top inset.
							borderTop:
								"var(--safe-area-inset-top) solid var(--mantine-color-body)",
							paddingBottom: "var(--safe-area-inset-bottom)",
							paddingLeft: "var(--safe-area-inset-left)",
							paddingRight: "var(--safe-area-inset-right)",
						}
					: {},
			}),
		}),
		DateTimePicker: {
			defaultProps: {
				valueFormat: "MM/DD/YY h:mm A",
				size: defaultInputSize,
			},
		},
		Loader: {
			defaultProps: {
				type: "bars",
				size: "lg",
			},
		},
		Drawer: {
			styles: {
				content: {
					paddingBottom: "var(--safe-area-inset-bottom)",
					paddingLeft: "var(--safe-area-inset-left)",
					paddingRight: "var(--safe-area-inset-right)",
					backgroundColor: "var(--mantine-color-body)",
				},
				header: {
					// place top padding on header to avoid scroll content from being visible above the header
					paddingTop: "var(--safe-area-inset-top)",
				},
				title: {
					fontWeight: 700,
					fontSize: 18,
				},
			},
		},
	},
});
